import { render, staticRenderFns } from "./CustomAcknowledgment.vue?vue&type=template&id=f3afff92&"
import script from "./CustomAcknowledgment.vue?vue&type=script&lang=ts&"
export * from "./CustomAcknowledgment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports